/* eslint no-console: ["error", { allow: ["warn", "error"] }] */

import $ from 'jquery';

const alerts = Array.from(document.querySelectorAll('.js-alert'));
const header = document.querySelector('.header');

alerts.forEach((alert) => {
    const dismisser = alert.querySelector('.js-dismiss');
    dismisser.addEventListener('click', (e) => {
        alert.parentNode.removeChild(alert);
        header.classList.remove('header--announcement');

        // special treatment for the top alerts from /app/templates/_includes/alert.html
        // we want to inform the body that there is an alert the class has been removed to change layout accordingly
        if (alert.id === 'wrapper--alert-on-top') {
            $('body').removeClass('has-alert-on-top');
        }

        e.stopPropagation();
        e.preventDefault();

        return false;
    });
});

// special treatment for the top alerts from /app/templates/_includes/alert.html
// we want to inform the body that there is an alert to change layout accordingly
(() => {

    if ($('#wrapper--alert-on-top').length) {
        $('body').addClass('has-alert-on-top');
    }

})();



// WEBPACK FOOTER //
// ./app/scripts/components/alert.js